/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface AttestationBase
 */
export interface AttestationBase {
    /**
     * 
     * @type {string}
     * @memberof AttestationBase
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof AttestationBase
     */
    challenge_type: ChallengeType;
}

/**
 * Check if a given object implements the AttestationBase interface.
 */
export function instanceOfAttestationBase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function AttestationBaseFromJSON(json: any): AttestationBase {
    return AttestationBaseFromJSONTyped(json, false);
}

export function AttestationBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttestationBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
    };
}

export function AttestationBaseToJSON(value?: AttestationBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
    };
}

